// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAppSelector } from 'Hooks';

// Whether the screen belongs to the catalog flow — a flag-on utilities project. The screens the catalog shares with
// AEC orders (the sidebar's order button, the order form's forward button, the buffer, coverage and request dialogs)
// read it before colouring their one next step orange (AUT-6630 D4); AEC keeps its buttons.
export const useCatalogFlow = (): boolean => {
  const { utilitiesCatalog } = useFlags();
  const projectType = useAppSelector((state) => state.project.project?.type);
  return utilitiesCatalog === true && projectType === 'utilities';
};

export default useCatalogFlow;
